module.exports = __webpack_public_path__ + "img/22.fe492521.png";